export const UserRoutes = {
  users: {
    me: () => '/rpm/api/v1/users/me',
    patientData: () => '/patient/api/v1/users/me',
  },
  patients: {
    updateEmergencyContact: (patientId: string) => `/patient/api/v1/patients/${patientId}/update-emergency-contact`,
    updatePatientInformation: (patientId: string) => `/patient/api/v1/patients/${patientId}/update-patient-information`,
    details : (patientId: string) => `/patient/api/v1/patients/${patientId}`,
  },
  docs: {
    legalContent: (organizationId: string, type: string) =>
      `/rpm/api/v1/organizations/${organizationId}/legal-content?type=${encodeURIComponent(type)}`,
  }
}
